import { GET, POST } from './Request'
import { LOGOUT_ROUTE, LOGIN_ROUTE, GCE_LOGIN_ROUTE, GCE_LOGOUT_ROUTE } from '../const/api'
import router from './../router/index'
import store from '../store/index'
import Types from '../store/types'
import iziToast from './iziToaster'

async function login(formData) {
  try {
    // console.log('Login :');
    const response = await POST(LOGIN_ROUTE, formData);
    // console.log(response);
    await store.dispatch(Types.actions.UPDATE_USER_TOKEN, response.data)
    router.push({
      name: 'profile'
    })
    iziToast.success({
      message: 'Successfully Logged In.'
    })
  } catch (error) {
    console.log(error);
    iziToast.error({
      title: 'Requirements or credentials do not match',
      message: ''
    })
  }
}

async function logout() {
  try {
    await GET(LOGOUT_ROUTE)
    await store.dispatch(Types.actions.UPDATE_AUTH_RESET)
    iziToast.success({
      message: 'Successfully Logged Out.'
    })
    setTimeout(() => {
      window.location.href = '/'
    }, 3000)
  } catch (error) {
    iziToast.error({
      message: 'Something went wrong. Try Again.'
    })
  }
}

async function gce_login(formData) {
  try {
    const response = await POST(GCE_LOGIN_ROUTE, formData)
  
    await store.dispatch(Types.actions.UPDATE_GCE_USER_TOKEN, response.data)
    
    iziToast.success({
      message: 'Successfully Logged In.'
    })
     setTimeout(() => {
      window.location.href = '/gce/dashboard'
    }, 1500)
  } catch (error) {
    iziToast.error({
      title: 'Requirements or credentials do not match',
      message: error.response.data.error
    })
  }
}

async function gce_logout() {
  try {
    await GET(GCE_LOGOUT_ROUTE)
    await store.dispatch(Types.actions.UPDATE_GCE_AUTH_RESET)
    iziToast.success({
      message: 'Successfully Logged Out.'
    })
    setTimeout(() => {
      window.location.href = '/gce/login'
    }, 3000)
  } catch (error) {
    iziToast.error({
      message: 'Something went wrong. Try Again.'
    })
  }
}

export { login, logout, gce_login, gce_logout}
